module.exports = __webpack_public_path__ + "img/alex_assessment.1f8e2c57.svg";